import React, { useContext, useEffect, useState } from "react";
import { Container, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { AuthContext } from "../Contexts/AuthContext";
import { AuthService } from "../services/api/Auth/AuthService";
import { useNavigate } from "react-router-dom";

import { useCookies } from 'react-cookie';
import { PermissoesService } from "../services/api/Usuarios/PermissoesService";

const Header = () => {
    const HASH_COOKIE = process.env.REACT_APP_COOKIE_HASH;

    const { auth, setAuth } = useContext(AuthContext)
    const [cookies, setCookie, removeCookie] = useCookies([HASH_COOKIE], { doNotParse: true });
    const [permissoesAreas, setPermissoesAreas] = useState([])

    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('us_hsp'))
    //console.log(auth)

    const fetchPermissoesAreas = async () => {
        const data = await PermissoesService.verificaPermissaoAreas()

        if (data.success) {
            setPermissoesAreas(data.data)
        }
    }

    const handleLogout = () => {
        setAuth(false);
        removeCookie([HASH_COOKIE])
        AuthService.logout();
        navigate('/login')


    }
    useEffect(() => {
        fetchPermissoesAreas()
    }, [])

    return (
        <Navbar expand="lg" bg="primary" data-bs-theme="dark" style={{ padding: 0, minHeight: '46px' }} id="menuPrincipal">

            <Container fluid={true}>

                <Navbar.Brand href="#inicio" className="bold">HospPET</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"></Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/admin/inicio">Inicio</Nav.Link>

                        {(permissoesAreas?.find(perm => perm.id == 2)) ? <Nav.Link href="/admin/agenda">Agenda*</Nav.Link> : ''}
                        {(permissoesAreas?.find(perm => perm.id == 3)) ? <Nav.Link href="/admin/clientes">Clientes</Nav.Link> : ''}
                        {(permissoesAreas?.find(perm => perm.id == 4)) ? <Nav.Link href="/admin/profissionais">Profissionais</Nav.Link> : ''}
                        {(permissoesAreas?.find(perm => perm.id == 6)) ?
                            <NavDropdown title="Finanças*" id="basic-nav-dropdown">
                                <NavDropdown.Item href="/admin/financas/comandas">Comandas*</NavDropdown.Item>
                                <NavDropdown.Item href="/admin/financas/contasPagar">Contas a pagar*</NavDropdown.Item>
                                <NavDropdown.Item href="/admin/financas/contasReceber">Contas a receber*</NavDropdown.Item>
                            </NavDropdown> : ''}

                        {(permissoesAreas?.find(perm => perm.id == 5)) ?
                            <NavDropdown title="Configurações" id="basic-nav-dropdown">
                                <NavDropdown.Item href="/admin/configuracoes/empresas">Configurações do Sistema</NavDropdown.Item>
                            </NavDropdown> : ''}
                    </Nav>
                    <Navbar.Text className="mr-15">
                        <img src={user?.thumb} style={{ maxWidth: '30px' }} className="rounded-circle" />
                        <span style={{ verticalAlign: 'middle' }}>  Olá <b style={{ color: '#FFF' }}> {user?.nome}!</b></span>
                    </Navbar.Text>
                    <Navbar.Text >
                        <a href="#" onClick={() => handleLogout()}>Sair</a>
                    </Navbar.Text>
                </Navbar.Collapse>


            </Container>

        </Navbar>
    )


}

export default Header;